import { render } from "./HSAccordion.vue?vue&type=template&id=b989672e&scoped=true"
import script from "./HSAccordion.vue?vue&type=script&lang=js"
export * from "./HSAccordion.vue?vue&type=script&lang=js"

import "./HSAccordion.vue?vue&type=style&index=0&id=b989672e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b989672e"]])

export default __exports__